import React, { useState } from 'react';
import get from 'lodash.get';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { classNames, trigger } from '@philips-internal/oswald-ui-utils';
import { ReactComponent as ShowMoreIcon } from '../../../../../resources/assets/components/DLS_MoreVertical.svg';
import { Popover } from '../../../popover/popover.js';
import './side-tabs.css';
function SideTabs(props) {
    const { tabs, onItemClick, } = props;
    const [open, setOpen] = useState(false);
    if (!tabs.length) {
        return null;
    }
    const triggerClickAndClose = (tabProps) => {
        const { enabled } = tabProps;
        if (!enabled) {
            return;
        }
        const value = get(tabProps, 'name');
        onItemClick(new ClickEvent({ value }));
        setOpen(false);
    };
    const renderItem = (tabProps) => {
        const { enabled, label, uuid, visible } = tabProps;
        if (!visible) {
            return null;
        }
        const className = classNames({
            'c-side-tabs__item': true,
            'disabled': !enabled,
        });
        return (React.createElement("div", { className: className, key: String(uuid), onClick: trigger(triggerClickAndClose, tabProps) },
            React.createElement("span", null, MessageService.translate(String(label ?? '')))));
    };
    return (React.createElement(Popover, { onClose: trigger(setOpen, false), open: open, showArrow: true },
        React.createElement("div", { className: "c-side-tabs__show-more-icon" },
            React.createElement(ShowMoreIcon, { onClick: trigger(setOpen, true) })),
        React.createElement(Popover.Content, null,
            React.createElement("div", { className: "c-side-tabs__items" }, tabs.map(renderItem)))));
}
export { SideTabs, };
//# sourceMappingURL=side-tabs.js.map